import React, { Dispatch } from "react";
import { Toggle } from "@amzn/awsui-components-react";
import {
  FullAsinWithAudits,
  RestrictedAsin,
} from "../../server/asin-central/model";
import { useDispatch, useSelector } from "react-redux";
import { setAll3pse, setAllIndexSuppressed } from "./oneClickLaunchConnector";
import { capitalize } from "../../util/stringUtils";
import { ItemToggleType } from "./ItemToggle";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import { RootState } from "../app/rootReducer";

export interface HeaderToggleProps {
  type: ItemToggleType;
  label: string;
}

const dispatchActions = {
  indexSuppressed: (
    items: (FullAsinWithAudits | RestrictedAsin)[],
    isSet: boolean,
    dispatch: Dispatch<any>
  ) => dispatch(setAllIndexSuppressed({ items: items, value: isSet })),
  "3PSE": (
    items: (FullAsinWithAudits | RestrictedAsin)[],
    isSet: boolean,
    dispatch: Dispatch<any>
  ) => dispatch(setAll3pse({ items: items, value: isSet })),
};

export default (props: HeaderToggleProps) => {
  const [checked, setChecked] = React.useState(false);
  const dispatch = useDispatch();
  const { asinMarketplaces } = useSelector(
    (state: RootState) => state.asinOneClickLaunchTableControl
  );
  return (
    <div>
      <SpaceBetween direction={"vertical"} size={"xxs"}>
        <text>{props.label}</text>{" "}
        <div style={{ textAlign: "center", display: "flex" }}>
          <div style={{ margin: "auto" }}>
            <Toggle
              checked={checked}
              onChange={({ detail }) => {
                setChecked(detail.checked);
                dispatchActions[props.type]?.(
                  asinMarketplaces,
                  detail.checked,
                  dispatch
                );
              }}
            >
              {capitalize(`${checked}`)}
            </Toggle>
          </div>
        </div>
      </SpaceBetween>
    </div>
  );
};
